
import ar from './locales/ar.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';
import nl from './locales/nl.json';
import ja from './locales/ja.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import tr from './locales/tr.json';
import { defaultLanguage, fallbackLanguage } from './config';

export const translations = {
  ar,
  en,
  es,
  fr,
  de,
  zh,
  ru,
  nl,
  ja,
  it,
  pt,
  tr,
};

const getNestedValue = (object, key) => {
  if (!object || !key) {
    return undefined;
  }

  return key.split('.').reduce((currentValue, keyPart) => {
    if (
      currentValue &&
      Object.prototype.hasOwnProperty.call(currentValue, keyPart)
    ) {
      return currentValue[keyPart];
    }

    return undefined;
  }, object);
};

const replaceParams = (text, params = {}) => {
  if (typeof text !== 'string') {
    return text;
  }

  return Object.entries(params).reduce((result, [key, value]) => {
    return result.replaceAll(`{{${key}}}`, String(value));
  }, text);
};

export const translate = (key, language = defaultLanguage, params = {}) => {
  const selectedLanguage = translations[language] ? language : defaultLanguage;

  const translatedValue =
    getNestedValue(translations[selectedLanguage], key) ??
    getNestedValue(translations[fallbackLanguage], key) ??
    getNestedValue(translations[defaultLanguage], key);

  if (translatedValue === undefined || translatedValue === null) {
    return key;
  }

  return replaceParams(translatedValue, params);
};

export default translate;
